/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserCouponPayAvailableRespVo } from './GetUserCouponPayAvailableRespVo';
import {
    GetUserCouponPayAvailableRespVoFromJSON,
    GetUserCouponPayAvailableRespVoFromJSONTyped,
    GetUserCouponPayAvailableRespVoToJSON,
    GetUserCouponPayAvailableRespVoToJSONTyped,
} from './GetUserCouponPayAvailableRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetUserCouponPayAvailableRespVo
 */
export interface ResponseListGetUserCouponPayAvailableRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetUserCouponPayAvailableRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetUserCouponPayAvailableRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetUserCouponPayAvailableRespVo>}
     * @memberof ResponseListGetUserCouponPayAvailableRespVo
     */
    data?: Array<GetUserCouponPayAvailableRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetUserCouponPayAvailableRespVo interface.
 */
export function instanceOfResponseListGetUserCouponPayAvailableRespVo(value: object): value is ResponseListGetUserCouponPayAvailableRespVo {
    return true;
}

export function ResponseListGetUserCouponPayAvailableRespVoFromJSON(json: any): ResponseListGetUserCouponPayAvailableRespVo {
    return ResponseListGetUserCouponPayAvailableRespVoFromJSONTyped(json, false);
}

export function ResponseListGetUserCouponPayAvailableRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetUserCouponPayAvailableRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetUserCouponPayAvailableRespVoFromJSON)),
    };
}

export function ResponseListGetUserCouponPayAvailableRespVoToJSON(json: any): ResponseListGetUserCouponPayAvailableRespVo {
    return ResponseListGetUserCouponPayAvailableRespVoToJSONTyped(json, false);
}

export function ResponseListGetUserCouponPayAvailableRespVoToJSONTyped(value?: ResponseListGetUserCouponPayAvailableRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetUserCouponPayAvailableRespVoToJSON)),
    };
}

